module.exports = __webpack_public_path__ + "static/img/hsseq2.96646e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hsseq2.png
// module id = Mrij
// module chunks = 1